<h1>{{ errorTitle }}</h1>
<p>{{ errorMessage }}</p>
<davinci-link class="link" icon="hardware/keyboard_arrow_left" inside-text (click)="goBack()">
  {{ 'error.back' | translate }}
</davinci-link>
<davinci-link class="link" icon="action/home" inside-text [routerLink]="['/manifest']">
  {{ 'error.overview' | translate }}
</davinci-link>
